import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Row, Col, Popover, PopoverBody } from "reactstrap";
import { userAxios } from "APIs";

interface StatusComponentProps{
  customerId:any;
  initialStatus:any;
  onUpdate:any ;
  role: any;
}

const StatusComponent: React.FC<StatusComponentProps> = ({
  customerId,
  initialStatus = "",
  onUpdate,
  role = "",
})  => {
  const [customerStatus, setCustomerStatus] = useState(initialStatus);
  const [newStatus, setNewStatus] = useState(initialStatus);
  const [isOpenPopover, setIsOpenPopover] = useState(false);

  useEffect(() => {
    const savedStatus = localStorage.getItem(`customerStatus-${customerId}-${role}`);
    if (savedStatus) {
      setCustomerStatus(savedStatus);
      setNewStatus(savedStatus);
    }
  }, [customerId, role]);

  const toggleStatusButton = () => {
    setIsOpenPopover(!isOpenPopover);
  };

  const handleToggleChange = () => {
    setNewStatus(newStatus === "Active" ? "Deactivate" : "Active");
  };

  const handleUpdateStatus = async () => {
    if (newStatus === customerStatus) {
      toast.info("No changes made.");
      toggleStatusButton();
      return;
    }

    try {
      if (newStatus === "Deactivate") {
        const response = await userAxios.delete(`/users/${customerId}`);
        console.log("status update.....",response)
        console.log(`${role} deactivated:`, response.data);
        toast.success(`${role} deactivated successfully`);
      } else {
        const response = await userAxios.patch(`/userActive/${customerId}?role=${role}`);
        console.log(",,,,",response)
        console.log(`${role} activated:`, response.data);
        toast.success(`${role} activated successfully`);
      }

      setCustomerStatus(newStatus); 
      localStorage.setItem(`customerStatus-${customerId}-${role}`, newStatus);
      if (onUpdate) onUpdate(newStatus);
    } catch (err) {
      console.error(`Error updating ${role} status:`, err);
      toast.error(`Failed to update ${role} status`);
    } finally {
      toggleStatusButton();
    }
  };

  return (
    <Col xs="4">
      <h6 className="mb-0 mt-3 adminLabel">Status</h6>
      <p className="mb-2 adminDetail" onClick={toggleStatusButton} style={{ cursor: "pointer" }}>
        {customerStatus}{" "}
        <i
          className={`bi ${isOpenPopover ? "bi-chevron-up" : "bi-chevron-down"}`}
          id={`StatusButton-${customerId}-${role}`}
        ></i>
      </p>
      {isOpenPopover && (
        <Popover
          placement="bottom"
          isOpen={isOpenPopover}
          target={`StatusButton-${customerId}-${role}`}
          toggle={toggleStatusButton}
          popperClassName="status-popover"
        >
          <PopoverBody>
            <div className="status-option">
              <Row>
                <Col>
                  <p>Status</p>
                </Col>
                <Col>
                  <i
                    className={`bi ${newStatus === "Active" ? "bi-toggle-on" : "bi-toggle-off"}`}
                    style={{
                      fontSize: "24px",
                      color: newStatus === "Active" ? "green" : "gray",
                      cursor: "pointer",
                    }}
                    onClick={handleToggleChange}
                  ></i>
                </Col>
              </Row>
            </div>
            <div className="mb-2 button-continer">
              <button onClick={toggleStatusButton}>Cancel</button>
              <button onClick={handleUpdateStatus}>Update</button>
            </div>
          </PopoverBody>
        </Popover>
      )}
    </Col>
  );
};

export default StatusComponent;
